import React from 'react'
import { enterHoverAnimation, leaveHoverAnimation } from '../timesheetUtils';

const SchoolTabsTimesheet = ({timesheets, invoices, tab, setSchoolTab, schoolTab}) => {

    const tallyUpSubmittedTimesheetsAndInvoices = (school, typeOfSheet) => {
        return typeOfSheet === 'timesheets' ? tallyUpSubmittedTimesheets(school) : tallyUpSubmittedInvoices(school)
    }

    const tallyUpSubmittedTimesheets = (school) => {
        let total = 0;
        for(let i = 0; i < timesheets.length; i++) {
            if(timesheets[i].school === school) {
                if(timesheets[i].status === 'submitted') {
                    total = total + 1
                }
            }
        }
        return total
    }

    const tallyUpSubmittedInvoices = (school) => {
        let invoiceTotal = 0;
        for(let i = 0; i < invoices.length; i++) {
            if(invoices[i].school === school) {
                if(invoices[i].status === 'Created') {
                    invoiceTotal = invoiceTotal + 1
                }
            }
        }
        return invoiceTotal
    }

    return (
        <div className="whole-billing-page__tab-wrapper sub-tab-wrapper">
            <h5 className="whole-billing-page__tabs sub-school-tab" id="mma-tab" onMouseEnter={() => enterHoverAnimation("mma-tab", 'mma', tab, schoolTab)} onMouseLeave={() => leaveHoverAnimation("mma-tab", 'mma', tab, schoolTab)} onClick={() => setSchoolTab('mma')}>Mountainside</h5>
            {tallyUpSubmittedTimesheetsAndInvoices('mma', tab) === 0 ? null : <div className="number-of-submitted-timesheets-and-invoices">{tallyUpSubmittedTimesheetsAndInvoices('mma', tab)}</div>}
            <h5 className="whole-billing-page__tabs sub-school-tab" id="lsma-tab" onMouseEnter={() => enterHoverAnimation("lsma-tab", 'lsma', tab, schoolTab)} onMouseLeave={() => leaveHoverAnimation("lsma-tab", 'lsma', tab, schoolTab)} onClick={() => setSchoolTab('lsma')}>Lakeside</h5>
            {tallyUpSubmittedTimesheetsAndInvoices('lsma', tab) === 0 ? null : <div className="number-of-submitted-timesheets-and-invoices">{tallyUpSubmittedTimesheetsAndInvoices('lsma', tab)}</div>}
            <h5 className="whole-billing-page__tabs sub-school-tab" id="tma-tab" onMouseEnter={() => enterHoverAnimation("tma-tab", 'tma', tab, schoolTab)} onMouseLeave={() => leaveHoverAnimation("tma-tab", 'tma', tab, schoolTab)} onClick={() => setSchoolTab('tma')}>Treeside</h5>
            {tallyUpSubmittedTimesheetsAndInvoices('tma', tab) === 0 ? null : <div className="number-of-submitted-timesheets-and-invoices">{tallyUpSubmittedTimesheetsAndInvoices('tma', tab)}</div>}
            <h5 className="whole-billing-page__tabs sub-school-tab" id="mor-tab" onMouseEnter={() => enterHoverAnimation("mor-tab", 'mor', tab, schoolTab)} onMouseLeave={() => leaveHoverAnimation("mor-tab", 'mor', tab, schoolTab)} onClick={() => setSchoolTab('mor')}>Morningside</h5>
            {tallyUpSubmittedTimesheetsAndInvoices('mor', tab) === 0 ? null : <div className="number-of-submitted-timesheets-and-invoices">{tallyUpSubmittedTimesheetsAndInvoices('mor', tab)}</div>}
        </div>
    )
}
export default SchoolTabsTimesheet